import React from 'react';

const PrivacyContent = () => {
    return (
        <div className="section-py bg-grey dark:bg-black">
            <div className="container lg:container mx-auto">
                <div className="row grid lg:grid-cols-12">
                    <div className="lg:col-span-8 lg:col-start-3 gap-5 flex flex-col">
                        <div>
                            <h1 className="fs-lg mb-1">Introduction</h1>
                            <p className="fs-md">
                                Moweb Limited (MTPL) respects your privacy. All information you give us is held with the utmost
                                care and security. To better protect your privacy we provide this notice explaining our online
                                information practices & the choices you can make about the way your information is collected and
                                used. We are committed to protecting personal information that you may share with us. This Privacy
                                Policy describes how we may collect and use your personal information. We do not sell, rent or
                                loan any identifiable information regarding our customers to any third party. Only in the
                                circumstances described within this Privacy Policy would we share your information with any third
                                party.
                            </p>
                            <p className="fs-md mb-0">
                                Any questions regarding MTPLs privacy policy should be directed to the Data Controller at or
                                alternatively see the section Contact us.
                            </p>
                        </div>
                        <div>
                            <h2 className="fs-lg mb-1">The Information We Collect:</h2>
                            <p className="fs-md">
                                This notice applies to all information collected or submitted on the our website. The information
                                we collect via the Website may include:
                            </p>
                            <ul className="list fs-md mb-0 text-secondary">
                                <li className="mb-1">
                                    Any personal details you knowingly provide us with through forms and our email, such as name,
                                    address, telephone number etc.
                                </li>
                                <li className="mb-1">
                                    Your IP Address, this is a string of numbers unique to your computer that is recorded by our
                                    web server when you request any page or component on the Website. This information is used to
                                    monitor your usage of the Website.We use IP addresses to help us administer the site, to
                                    collect broad demographic information for aggregate use and to track your engagement with us.
                                </li>
                                <li className="mb-1">
                                    Data recorded by the website that allows us to recognize you and your preferred settings. Such
                                    data is recorded locally on your computer through the use of cookies. Most browsers can be
                                    programmed to reject, or warn you before downloading cookies, information regarding this may
                                    be found in your browsers help facility.
                                </li>
                                <li>
                                    We may automatically collect non-personal information about you, such as the type of Internet
                                    browsers you use and the site from which you linked to our site. You cannot be identified from
                                    this information and it is only used to assist us in providing an effective service on our
                                    site.
                                </li>
                            </ul>
                        </div>
                        <div>
                            <h2 className="fs-lg mb-1">What we do with your information</h2>
                            <p className="fs-md">
                                MTPL will not collect any personal information about individuals except as set out in this privacy
                                policy.
                            </p>
                            <p className="fs-md">
                                Examples of the types of personal information we will collect are: name, company, postal address,
                                email address, phone number, details of website and product usage and product commentary. Any
                                personal information we collect from this website will be used in accordance with the Data
                                Protection Act and other applicable laws. The details we collect will be used:
                            </p>
                            <ul className="list fs-md text-secondary">
                                <li className="mb-1">
                                    To respond to any enquiries you have made. And to keep records of who has contacted us.
                                </li>
                                <li className="mb-1">
                                    In certain cases we may use your personal information to send you information on our other
                                    products and services. In such a case you will be offered the option to opt in/out.
                                </li>
                                <li className="mb-1">
                                    We may use it to send you our newsletter, where this is requested by you and track your
                                    engagement with us, including through our website, articles and newsletters;
                                </li>
                                <li className="mb-1">
                                    The email address Users provide will only be used to respond to their inquiries, and/or other
                                    requests or questions. If User decides to opt-in to our mailing list, they will receive emails
                                    that may include company news, updates, related product or service information, etc. If at any
                                    time the User would like to unsubscribe from receiving future emails, they may do so by
                                    contacting us via our Site
                                </li>
                                <li className="mb-1">
                                    We may also use your information to send you, or to have our business partners send you,
                                    direct marketing information or contact you for market research.
                                </li>
                            </ul>
                            <p className="fs-md mb-0">
                                You can register with our website if you would like to receive our newsletter as well as updates
                                on our new products and services. Information you submit on our website will not be used for this
                                purpose unless you subscribe for the newsletter. Finally, we never use or share the personally
                                identifiable information provided to us online in ways unrelated to the ones described above
                                without also providing you an opportunity to opt-out or otherwise prohibit such unrelated uses.
                            </p>
                        </div>
                        <div>
                            <h2 className="fs-lg mb-1">How We Protect Your Information?</h2>
                            <p className="fs-md">
                                To prevent unauthorized access, maintain data accuracy, and ensure the correct use of information,
                                we have put in place appropriate physical, electronic, and managerial procedures to safeguard and
                                secure the information we collect online. We have strict security procedures covering the storage
                                of your information in order to prevent unauthorized access.
                            </p>
                            <p className="fs-md mb-0">
                                We have implemented technology and policies to help safeguard your privacy from unauthorized
                                access and improper use. We will continue to monitor and update security measures as new
                                technology becomes available as appropriate to the site.
                            </p>
                        </div>
                        <div>
                            <h2 className="fs-lg mb-1">How we use cookies on our website</h2>
                            <p className="fs-md">
                                A cookie is a small text file that is stored on a users computer for tracking and record-keeping
                                purposes. Our Site may use cookies to enhance User experience. We will use such cookies to
                                identify unique users to our sites. They are not cross-referenced with any other information such
                                that an individual person could be identified.
                            </p>
                            <p className="fs-md mb-0">
                                Users have the ability to accept or disable cookies by modifying the settings in their browser.
                                Disabling cookies, however, may mean that some functionality may be affected.
                            </p>
                        </div>
                        <div>
                            <h2 className="fs-lg mb-1">What we share with third parties</h2>
                            <p className="fs-md mb-0">
                                We use Google Analytics, which drops cookies via our website and collects non-personally
                                identifiable information about you, so we can understand how you use our website. By agreeing to
                                the terms of this privacy policy, you consent to the cookies referenced above being dropped onto
                                your machine.
                            </p>
                        </div>
                        <div>
                            <h2 className="fs-lg mb-1">Disclosures</h2>
                            <p className="fs-md mb-0">
                                Other than the disclosures referred to in this policy, we will not disclose any personal
                                information without your permission unless we are legally obliged or entitled to do so (for
                                example, if required to do so by Court order or for the purposes of identifying fraud or other
                                crime).
                            </p>
                        </div>
                        <div>
                            <h2 className="fs-lg mb-1">Information about our products and services</h2>
                            <p className="fs-md mb-0">
                                It is very important to us that we provide you with the highest level of service. In order to help
                                us do this, from time to time Red Gate may send you, with your consent, details of our products
                                and services that we think may be of interest to you. If at any time you do not wish to continue
                                to receive these details, then send a blank email message to unsubscribe@moweb.com. You can also
                                unsubscribe from our newsletter by using the unsubscribe option located in each of our newsletter
                                communications.
                            </p>
                        </div>
                        <div>
                            <h2 className="fs-lg mb-1">Your Acceptance of These Terms</h2>
                            <p className="fs-md mb-0">
                                By using this Site, you signify your acceptance of this policy and terms of service. If you do not
                                agree to this policy, please do not use our Site. Your continued use of the Site following the
                                posting of changes to this policy will be deemed your acceptance of those changes.
                            </p>
                        </div>
                        <div>
                            <h2 className="fs-lg mb-1">Changes to this Privacy Policy</h2>
                            <p className="fs-md mb-0">
                                We may amend this Privacy Policy from time to time. If we make any substantial changes in the way
                                we use your personal information we will make that information available by posting on this site.
                                We may also, but are not required to, notify you by email or regular mail.
                            </p>
                        </div>
                        <div>
                            <h2 className="fs-lg mb-1">Contacting us</h2>
                            <p className="fs-md mb-0">
                                If at any time you would like to contact us with your views about our privacy practices, or with
                                any enquiry relating to your personal information, you can do so by sending an email to us at
                                privacy@moweb.com or by contacting us at Moweb Technologies Private Limited, 403 Shanti House,
                                Near Navrangpura Telephone Exchange, Off C G Road, Ahmedabad, Gujarat, India
                            </p>
                        </div>
                        <div>
                            <h2 className="fs-lg mb-1">Other Websites</h2>
                            <p className="fs-md mb-0">
                                This privacy policy only covers this website. Any other websites which may be linked to by our
                                website are subject to their own policy, which may differ from ours.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PrivacyContent;
